import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "authReducer",
  initialState: {
    user: {},
    isLogout: false,
    pageTitle: "",
    accountDetails: {},
  },
  reducers: {
    setPageTitle: (state, action) => {
      const { payload } = action;
      state.pageTitle = payload;
    },
    setUserInfo: (state, action) => {
      const { payload } = action;
      state.user = payload;
    },
    setAccountsInfo: (state, action) => {
      const { payload } = action;
      state.accountDetails = payload;
    },
  },
});

export const {
  actions: { setPageTitle, setUserInfo, setAccountsInfo },
  reducer: authReducer,
} = authSlice;
